import React from 'react';

import styles from './Footer.module.scss';
import stillfrontLogo from '../../assets/images/stillfront_logo_white.png';

import {
    SHOP_PATHNAME,
    LOGIN_PATHNAME,
    WEBSITE_URL_TERMS_OF_USE,
    WEBSITE_URL_PRIVACY_POLICY,
    WEBSITE_URL_FAQ,
    WEBSITE_URL_SUPPORT,
    MILESTONES
} from '../../shared/constants';

const Footer = ({ windowSize, config }) => {
    let additionalClass = '';
    // rebase 2 from master
    if (windowSize.isMobileView && window.location.pathname === SHOP_PATHNAME) {
        additionalClass = styles.additionalMobileClass;
    }
    if (window.location.pathname === LOGIN_PATHNAME) {
        additionalClass = styles.additionalLoginClass;
    }
    if (window.location.pathname === MILESTONES) {
        additionalClass = styles.additionalMilestonesClass;
    }

    return (
        <div className={`${styles.footerWrapper} ${additionalClass}`}>
            {/*<img src={stillfrontLogo} alt="Stillfront Group" className={styles.stillfront_logo} />*/}
            <div>&copy; {new Date().getFullYear()} Imperia Online - Part of Stillfront. All rights reserved.</div>
            <div className={styles.termsWrapper}>
                {/*<a href={WEBSITE_URL_TERMS} className={styles.terms}>{config.termsAndConditions}</a>*/}
                {/*<a href={WEBSITE_URL_PRIVACY} className={styles.terms}>{config.privacyPolicy}</a>*/}
                <a href={WEBSITE_URL_TERMS_OF_USE} className={styles.terms}>{config.termsAndConditions}</a>
                <div className={styles.footerDivider}></div>
                <a href={WEBSITE_URL_PRIVACY_POLICY} className={styles.terms}>{config.privacyPolicy}</a>
                <div className={styles.footerDivider}></div>
                <a href={WEBSITE_URL_FAQ} className={styles.faq}>{config.faq}</a>
                <div className={styles.footerDivider}></div>
                <a href={WEBSITE_URL_SUPPORT} className={styles.support}>{config.support}</a>
            </div>
        </div>
    );
};

export default Footer;